module.exports = __webpack_public_path__ + "media/application/images/svgs/minus-circle-b9f4fc166ecdb2eba005e3632889050f.svg";